// extracted by mini-css-extract-plugin
export default {"callback-container":"callback_callback-container__OxpD9","callback-card":"callback_callback-card__bHpOk","icon-container":"callback_icon-container__3XqQK"};